import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-missed-info',
  templateUrl: './missed-info.component.html',
  styleUrls: ['./missed-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MissedInfoComponent {
  constructor() { }
}
